import { addMessage } from './global-messages/global-messages'

export const showMessage = (dispatch, { code, msg }) => {
	if (code && msg) {
		dispatch(addMessage({ text: msg, type: 'error' }))
	} else {
		dispatch(addMessage({ text: msg, type: 'success' }))
	}
}
